import seriesCardTeaEvent from 'Components/new/series-card/tea'

export default function relatedSeriesTeaEvent(
  type: string,
  params?: Record<string, any>
) {
  const usefulParams: Record<string, any> = {}
  Object.keys(params || {}).forEach((key) => {
    if (params?.[key] === undefined) return
    usefulParams[key] = params?.[key]
  })
  seriesCardTeaEvent(type, usefulParams)
}
